import { render, staticRenderFns } from "./WICTransactionsGIA.vue?vue&type=template&id=7568e70e&"
import script from "./WICTransactionsGIA.vue?vue&type=script&lang=js&"
export * from "./WICTransactionsGIA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports